




















import Vue from 'vue'
import { putFilePOST } from '@/api/api'

export default Vue.extend({
  name: 'UploadImg',
  model: {
    prop: 'value',
    event: 'changeImg'
  },
  props: {
    name: {
      type: String
    },
    value: {
      type: String
    },
    className: {
      type: String,
      default: ''
    },
    fileLimit: {  // 限制的图片大小，默认为3MB，当传入值大于10时，默认单位是kb
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    beforeUpload(file: any) {
      let isLt = null
      const isJpgOrPng =
        file.type === 'image/jpeg' ||
        file.type === 'image/jpg' ||
        file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error(this.$t('page_theme_img_tip'))
      }
      if (this.fileLimit > 10) {
        // 单位kb
        isLt = file.size / 1024 < this.fileLimit
        if (!isLt) {
          this.$message.error(
            `${this.$t('page_theme_upload_tip')}${this.fileLimit}KB!`
          )
        }
      } else {
        // 单位MB
        isLt = file.size / 1024 / 1024 < this.fileLimit
        if (!isLt) {
          this.$message.error(
            `${this.$t('page_theme_upload_tip')}${this.fileLimit}MB!`
          )
        }
      }

      return isJpgOrPng && isLt
    },
    // 上传头像到华为云
    uploadImage(file: any) {
      // 图片校验
      const validate = this.beforeUpload(file.file)
      if(!validate) {
        return
      }
      this.loading = true
      const formData = new FormData()
      formData.append('file', file.file)
      putFilePOST(formData).then((res: any) => {
        // console.log('上传图片:', res)
        if (res) {
          this.$emit('changeImg', res.data.data.link)
        }
      }).finally(()=>{
        this.loading = false
      })
    }
  }
})
